const pre = '/bcos/audit/';

export default {
    path: '/bcos/audit',
    title: '交易审计',
    header: '',
    icon: 'md-stats',
    children: [
        {
            path: `${pre}transactionCharts`,
            title: '用户交易',
        },
        {
            path: `${pre}unusualUser`,
            title: '异常用户',
        },
        {
            path: `${pre}unusualContract`,
            title: '异常合约',
        },
    ]
}
